/**
 * The signed-in account's own record.
 *
 * NOT a patch, whatever the input's optional fields suggest: the resolver
 * clears `primaryResidencyId` and `investmentOptimizedResidencyId` when they
 * are absent (`user.py:257-265` — `else: = None` on both), so every caller must
 * send them back. `useMyResidency().keep` is that echo; spread it into the
 * input. The other fields behave as a patch.
 */
import { gql } from '@apollo/client';

export const UPDATE_PROFILE = gql`
  mutation UpdateProfile($input: UpdateUserSettingsInput!) {
    updateProfile(input: $input) {
      id
      name
      email
      phoneNumber
    }
  }
`;
